import React from 'react';
import styled from 'styled-components';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

const GeneralAccordion = (props) => {
  const { name, expanded, handleChange, updateStarChange, key, main, title, className, children } = props;

  const getIcon = () => {
    if (main) {
      if (name !== expanded) return <EditIcon />;
      return <CloseIcon />;
    }
    return <ExpandMoreIcon />;
  };

  return (
    <Accordion
      expanded={name === expanded}
      onChange={() => {
        if (name !== expanded) {
          handleChange(name);
        } else {
          handleChange(false);
          if (updateStarChange) updateStarChange();
        }
      }}
      className="drawers"
      key={key.toString() || 0}>
      <AccordionSummary expandIcon={getIcon()} aria-controls="panel1bh-content" id="panel1bh-header">
        <p
          style={{
            color: expanded === name ? '#6985FC' : '#93A0B6',
            margin: '0px',
            fontSize: '16px',
          }}>
          {title}
        </p>
      </AccordionSummary>
      <AccordionDetails>
        <div className={className}>{children}</div>
      </AccordionDetails>
    </Accordion>
  );
};

GeneralAccordion.propTypes = {
  name: PropTypes.string,
  expanded: PropTypes.string,
  handleChange: PropTypes.func,
  updateStarChange: PropTypes.func,
  key: PropTypes.string,
  main: PropTypes.bool,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.element,
};

GeneralAccordion.defaultProps = {
  name: '',
  expanded: '',
  handleChange: () => {},
  updateStarChange: () => {},
  key: '',
  main: false,
  title: '',
  className: '',
  children: <div />,
};

export default styled(GeneralAccordion)`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
`;
